import { render, staticRenderFns } from "./citationPushConfig.vue?vue&type=template&id=47347a32&scoped=true"
import script from "./citationPushConfig.vue?vue&type=script&lang=js"
export * from "./citationPushConfig.vue?vue&type=script&lang=js"
import style0 from "./citationPushConfig.vue?vue&type=style&index=0&id=47347a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47347a32",
  null
  
)

export default component.exports